export default __webpack_public_path__ + "static/media/clear-icon-grey-64.05b6337e.svg";